import { all } from 'redux-saga/effects'

import { loginSaga } from './login/saga'

export function* authSaga() {
  yield all([loginSaga()])
}
